{
  "__review_clinicalData": "Backend/clinician-authored API data (allergen/medication/problem/provider/result names, values, units, ranges, comments, message bodies) — Phase 9, do not translate",
  "enums": {
    "appointmentStatus": {
      "scheduled": "已預約",
      "confirmed": "已確認",
      "completed": "已完成",
      "cancelled": "已取消",
      "no-show": "未到診",
      "checked-in": "已報到"
    },
    "resultStatus": {
      "final": "最終",
      "preliminary": "初步",
      "corrected": "已更正"
    },
    "allergySeverity": {
      "severe": "嚴重",
      "high": "高",
      "moderate": "中度"
    },
    "nationalIdType": {
      "NRIC": "NRIC（新加坡身分證）",
      "HKID": "HKID（香港身分證）",
      "MyKad": "MyKad（馬來西亞身分證）",
      "Aadhaar": "Aadhaar（印度身分證）",
      "KTP": "KTP（印尼身分證）",
      "Passport": "護照"
    },
    "messageSenderType": {
      "provider": "醫護人員",
      "patient": "病患"
    }
  },
  "form": {
    "validation": {
      "passwordMismatch": "兩次輸入的密碼不一致",
      "passwordMinLength": "密碼至少需要 8 個字元"
    }
  },
  "labels": {
    "abnormal": "異常"
  },
  "pages": {
    "layout": {
      "nav": {
        "myHealth": "我的健康",
        "results": "檢驗結果",
        "appointments": "預約",
        "messages": "訊息",
        "forms": "表單"
      },
      "signOut": "登出",
      "signOutAria": "登出",
      "navAria": "入口網站導覽",
      "footer": "VynaEMR 病患入口網站 — FLOSTEL Healthcare IT"
    },
    "login": {
      "subtitle": "病患入口網站",
      "labels": {
        "email": "電子郵件",
        "password": "密碼"
      },
      "placeholders": {
        "email": "you@example.com",
        "password": "請輸入您的密碼"
      },
      "button": {
        "signIn": "登入",
        "signingIn": "登入中..."
      },
      "toast": {
        "welcome": "歡迎回來！",
        "invalid": "電子郵件或密碼無效"
      },
      "links": {
        "noAccount": "還沒有帳號？",
        "register": "註冊"
      }
    },
    "dashboard": {
      "greeting": {
        "morning": "早安",
        "afternoon": "午安",
        "evening": "晚安",
        "fallbackName": "您"
      },
      "subtitle": "以下是您的健康摘要。",
      "error": "無法載入您的健康摘要，請稍後再試。",
      "demographics": {
        "ageLabel": "{{age}} 歲",
        "bloodTypeLabel": "血型：{{bloodType}}"
      },
      "quickLinks": {
        "results": "檢驗結果",
        "appointments": "預約",
        "messages": "訊息",
        "forms": "表單"
      },
      "sections": {
        "allergies": "過敏",
        "activeMedications": "目前用藥",
        "activeProblems": "目前健康問題",
        "upcomingAppointments": "即將到來的預約",
        "recentResults": "最近結果",
        "immunizations": "疫苗接種紀錄",
        "emergencyContact": "緊急聯絡人"
      },
      "states": {
        "noAllergies": "沒有已記錄的過敏。",
        "noMedications": "沒有目前用藥。",
        "noAppointments": "沒有即將到來的預約。",
        "noResults": "沒有最近結果。"
      },
      "moreCount": "另有 {{count}} 項",
      "sinceDate": "自 {{date}} 起",
      "doseNumber": "第 {{number}} 劑",
      "viewAll": "查看全部",
      "providerTBD": "醫師待定"
    },
    "register": {
      "subtitle": "建立您的帳號",
      "labels": {
        "fullName": "姓名",
        "email": "電子郵件",
        "dateOfBirth": "出生日期",
        "phone": "電話",
        "mrn": "MRN（病歷號碼）",
        "idType": "證件類型",
        "idNumber": "證件號碼",
        "password": "密碼",
        "confirmPassword": "確認密碼"
      },
      "placeholders": {
        "fullName": "請輸入您的姓名",
        "email": "you@example.com",
        "phone": "+65 9123 4567",
        "mrn": "e.g. P0000000001",
        "idNumber": "請輸入您的證件號碼",
        "password": "至少 8 個字元",
        "confirmPassword": "請再次輸入密碼",
        "selectIdType": "請選擇..."
      },
      "mrnHint": "若要將帳號連結到您的病歷，請提供 MRN 或國民身分證號碼。",
      "button": {
        "createAccount": "建立帳號",
        "creatingAccount": "正在建立帳號..."
      },
      "toast": {
        "success": "註冊成功，請登入。",
        "failure": "註冊失敗，請再試一次。"
      },
      "links": {
        "haveAccount": "已有帳號？",
        "signIn": "登入"
      },
      "aria": {
        "dateOfBirth": "出生日期"
      }
    },
    "appointments": {
      "title": "預約",
      "subtitle": "查看與管理您的預約",
      "error": "無法載入預約，請稍後再試。",
      "sections": {
        "upcoming": "即將到來",
        "past": "過往"
      },
      "states": {
        "noUpcoming": "目前沒有即將到來的預約。",
        "noPast": "目前沒有過往的預約。"
      },
      "reasonLabel": "原因：{{reason}}",
      "instructionsLabel": "注意事項：{{instructions}}",
      "durationMinutes": "{{minutes}} 分鐘",
      "actions": {
        "cancel": "取消",
        "confirmCancel": "確認",
        "cancelling": "正在取消...",
        "keep": "保留"
      },
      "toast": {
        "cancelSubmitted": "已送出取消要求，您的照護團隊會與您確認。",
        "cancelFailed": "取消預約失敗，請致電診所。"
      }
    },
    "results": {
      "title": "我的報告",
      "subtitle": "查看您的檢驗與影像報告",
      "error": "無法載入報告，請稍後再試。",
      "referenceRange": "（參考值：{{range}}）",
      "states": {
        "noResults": "目前沒有報告。"
      }
    },
    "messages": {
      "title": "訊息",
      "subtitle": "與您的醫療團隊聯絡",
      "error": "無法載入訊息，請稍後再試。",
      "fromSender": "來自 {{name}}",
      "labels": {
        "subject": "主旨",
        "message": "訊息內容",
        "reply": "回覆"
      },
      "placeholders": {
        "subject": "訊息主旨",
        "message": "請輸入您的訊息...",
        "reply": "請輸入您的回覆..."
      },
      "actions": {
        "newMessage": "新訊息",
        "back": "返回訊息列表",
        "sendMessage": "傳送訊息",
        "sendReply": "傳送回覆",
        "sending": "正在傳送..."
      },
      "states": {
        "noMessages": "目前沒有訊息。"
      },
      "thread": {
        "fromSenderWithType": "來自 {{name}}（{{type}}）"
      },
      "compose": {
        "title": "新訊息",
        "subtitle": "您的訊息將傳送給您的醫療團隊。"
      },
      "toast": {
        "sent": "訊息已傳送",
        "sendFailed": "訊息傳送失敗"
      }
    },
    "forms": {
      "title": "表單",
      "subtitle": "填寫所需的表單與問卷",
      "error": "無法載入表單，請稍後再試。",
      "sections": {
        "pending": "待填寫",
        "completed": "已完成"
      },
      "labels": {
        "required": "必填"
      },
      "placeholders": {
        "select": "請選擇……"
      },
      "actions": {
        "fillOut": "填寫",
        "back": "返回表單列表",
        "submit": "送出表單",
        "submitting": "送出中……"
      },
      "states": {
        "noPending": "目前沒有待填寫的表單。",
        "noCompleted": "目前沒有已完成的表單。",
        "noFields": "此表單沒有需要填寫的欄位。"
      },
      "toast": {
        "submitted": "表單已成功送出",
        "submitFailed": "表單送出失敗"
      }
    }
  }
}
